enum EProduct {
  buyback = 'Buyback',
  channels = 'Channels',
  inbound = 'Inbound',
  inventory = 'Inventory',
  operations = 'Operations',
}

export default EProduct;
